const DbMenus = [
    {
        id: 105,
        title: '图书数据库',
        goto: { path: '/shop', query: { ftype: 'all' } },
        iclass: '',
    }, {
        id: 107,
        title: '术语库',
        goto: { path: '/db/term' },
        class: '',
    }, {
        id: 102,
        title: '问答库',
        goto: { path: '/db/qa' },
        class: ''
    }, {
        id: 101,
        title: '公式库',
        goto: { path: '/db/formula' },
        class: 'is-open',
    }, {
        id: 104,
        title: '符号库',
        goto: { path: '/db/param' },
        class: '',
    }, {
        id: 106,
        title: '标准查新',
        goto: { path: '/novelty' },
        class: '',
    }
]

export default DbMenus